
<script>
import defaultUserImage from '@/assets/images/avatar.png';
/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      user: {},
      defaultUserImage
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    getUserData() {
      this.$store.dispatch('USER_DATA').then((res) => {
        this.user = res;
      }).catch(() => {
        // console.log(err)
      })
    },
    logout() {
      this.$store.dispatch('AUTH_LOGOUT').then(() => {
        this.$router.push('/login')
      })
    }
  },
  mounted() {
    this.getUserData();
  }
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-avatar-color.png" alt height="28" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-bizmob-text-white.png" alt height="44" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-avatar-color.png" alt height="28" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-bizmob-text-white.png" alt height="44" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ml-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <!-- <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge badge-success badge-pill">3</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">Notificações</h6>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px;">
            <a href class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs mr-3">
                  <span class="avatar-title bg-primary rounded-circle font-size-16">
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">Novo Pedido Recebido</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">Você recebeu um novo pedido</p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i> 3 minutos atrás
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
        </b-dropdown> -->

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user mr-2"
              :src="`${user.logo_image || user.image || defaultUserImage}`"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ml-1">{{user.name || 'Administrador'}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block ml-2"></i>
          </template>
          <!-- item-->
          <!-- <a class="dropdown-item d-block" href="javascript: void(0);">
            <i class="bx bx-cog font-size-16 align-middle mr-1"></i> Configurações
          </a>
          <div class="dropdown-divider"></div> -->
          <a class="dropdown-item text-danger" @click="logout">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Sair
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
